import {Component} from 'react';

class NumberedListCard extends Component {
    constructor(props) {
        super(props);
        this.state = {open: false, selected: false};
    }

    checkForLabelText(){
        this.textFormat = "regular";
        if (this.props.text.label){
            this.textFormat = "label-text";
        }
    }

    render() {
        this.checkForLabelText();
    return <> 
        {this.textFormat === "label-text"  ?
            <li><b>{this.props.text.label}</b> - {this.props.text.text}</li>   
        :
            <li>{this.props.text}</li>
        }
           
    </>
    }
}

export default NumberedListCard;